
import {MapApi} from "@/engine/comm/api.js";
import {Identity} from "@/engine/identity.js";
import {Waiter} from "@/engine/helpers/waiter.js";
import {UIServiceMessenger} from "@/engine/UIServiceMessenger.js";
import {ShortLivedTokenManager} from "@/engine/comm/shortLivedTokenManager.js";
import {elog} from "@/engine/helpers/logging.js";

//Service Messenger (notifies the user with various messages)
export const sm = new UIServiceMessenger(true, null, null);

// Api service
export const mapApi = new MapApi()

// Short-lived credential used by protected data services such as GeoServer.
export const shortLivedTokenManager = new ShortLivedTokenManager(mapApi, elog)

// Identity control
export const identity = new Identity()

// The Main Control Object
export var mapContext = null

// The Waiter service
export const waiter = new Waiter()

export const defaultContext = {
    location: { latitude: -16.8275,
        longitude: -179.9348,
        zoom: 10,
    },
    // sent debug messages to remote logging server
    // temporary disabled cause overload the backend with http requests on heavy scenes with a lot of workspaces and layers
    remoteDebugLog: false,
    // не знаю для чего это
    app_portal_url: "https://maphub.online/",
    mapbox_access_token: "pk.eyJ1Ijoid29ybWl4IiwiYSI6ImNrcGk0NDRuMjBmaGEybnBjaG9zY2U5ZWEifQ.AX59GK8Tr6BWfoBXuXaNNg",
    // enable/disable developer mode for UI (debug pane and some debug info
    // todo devMode = false isn't supported now, need to fix empty mapContext.stat object if devMode disabled
    devMode: true,
    debugButtons: import.meta.env.DEV,  // enable/disable debug buttons
    debugConsoleLog: true,              // log debug messages to a console
    profiling: false,
    // Selects editable vector WFS-T implementation: "leaflet" keeps the legacy plugin, "openlayers" uses the new adapter.
    wfstBackend: "openlayers",
    templateVersion: encodeURIComponent(__BUILD_RAND_TAG_VERSION__),
};

window.maphub_elog_debug = defaultContext.remoteDebugLog;
window.maphub_profiling = defaultContext.profiling;

export function setMapContext(MapContext) {
    if (mapContext == null)
        mapContext  = MapContext;
    if (globalThis != null) {
        globalThis.mapContext = MapContext;
    }
}
